export default __webpack_public_path__ + "static/media/notRegister.faa458c5.svg";